import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import config from './config';
import '@/plugins/clipboard';
import '@/plugins/vue-page-transitions';
import vuetify from '@/plugins/vuetify';
import '@/plugins/vuetify-dialog';
import {restoreSession} from '@/helpers/auth';
import './data/di/index';
import mdiVue from 'mdi-vue/v2'
import * as mdijs from '@mdi/js'

Vue.use(mdiVue, {
  icons: mdijs
})

Vue.config.productionTip = config.tip;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  created() {
    restoreSession();
  },
  render: (h) => h(App),
}).$mount('#app');
